import * as classnames from 'classnames';
import * as React from 'react';

import { FormattedMessage } from 'react-intl';

import { WalletAccountTypeId } from 'constants/wallet';
import { WalletAccountType as WalletAccountTypeModel } from 'models/wallet';

import './WalletAccountTypeCard.scss';

interface WalletAccountTypeCardProps {
  className?: string;
  walletAccountType: WalletAccountTypeModel;
}

export class WalletAccountTypeCard extends React.Component<WalletAccountTypeCardProps, {}> {
  render() {
    const { className, walletAccountType } = this.props;
    const availableWalletAccountTypeId: string[] = [WalletAccountTypeId.LITE, WalletAccountTypeId.PRO];
    return availableWalletAccountTypeId.indexOf(walletAccountType.id) > -1 ?
    (
      <div className={classnames('wallet-account-type-card o-caption-2', className)}>
        <FormattedMessage id={'wallet.accountTypeId.' + walletAccountType.id}/>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Wallet/WalletAccountTypeCard/WalletAccountTypeCard.tsx